const CITIES = 'cities';
const NEIGHBOURHOODS = 'neighbourhoods';
const UNIVERSITIES = 'universities';

export { CITIES, NEIGHBOURHOODS, UNIVERSITIES };
